import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-review-request",
  "use": "foquz-icon-review-request-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-review-request\"><path d=\"M11.008 3.992H3.182C1.977 3.992 1 4.952 1 6.135v8.722C1 16.041 1.977 17 3.182 17h8.591C12.978 17 14 16.04 14 14.857c0 0 0 0 0 0V7m-2-4l3 3m-1-5l3 3-7 7H7V8l7-7z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol